import { componentQrl, inlinedQrl, useSignal, useId, useContextProvider, useTaskQrl, useLexicalScope, _jsxQ, _fnSignal, _jsxC, Slot } from "@builder.io/qwik";
import { CheckListContext } from "./context-id.qwik.mjs";
const ChecklistContextWrapper = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const helpme = useSignal([]);
  const idArr = [];
  const mehelp = useSignal(props.initialTriBool);
  const id = useId();
  for (let index = 0; index < props.arrSize; index++) {
    if (props.idArr[index] != false) {
      idArr.push(props.idArr[index]);
      continue;
    }
    const uniqId = id + index.toString();
    idArr.push(uniqId);
  }
  const obj = {
    checkboxes: helpme,
    checklistSig: mehelp,
    idArr
  };
  useContextProvider(CheckListContext, obj);
  useTaskQrl(/* @__PURE__ */ inlinedQrl(({ track }) => {
    const [obj2] = useLexicalScope();
    track(() => {
      return obj2.checkboxes;
    });
  }, "ChecklistContextWrapper_component_useTask_37p6S366rv4", [
    obj
  ]));
  return /* @__PURE__ */ _jsxQ("div", null, {
    role: "group",
    "aria-labelledby": _fnSignal((p0) => p0.ariaLabeledBy, [
      props
    ], "p0.ariaLabeledBy")
  }, /* @__PURE__ */ _jsxC(Slot, null, 3, "uY_0"), 1, "uY_1");
}, "ChecklistContextWrapper_component_csWXa0YckjA"));
function getTriBool(boolArr) {
  if (boolArr.length === 0)
    return "indeterminate";
  if (boolArr.every((e) => e === true))
    return true;
  if (boolArr.every((e) => e === false))
    return false;
  return "indeterminate";
}
export {
  ChecklistContextWrapper,
  getTriBool
};
